module.exports = __webpack_public_path__ + "img/octagon-plus.86c9d1f5.svg";